import { DegreeCompletionRequirement } from './degree_completion_requirement_builder';

export class DegreeCompletionBlock {

  static ngDegreeCompletionRequirementBuilder: typeof DegreeCompletionRequirement;

  title: string = '';
  requirements: DegreeCompletionRequirement[] = [];

  constructor(block: any) {
    _.merge(this, block);
    this.requirements = _.map(this.requirements, (requirement) => DegreeCompletionBlock.ngDegreeCompletionRequirementBuilder.build(requirement));
  }

  static build(block: any): DegreeCompletionBlock {
    return new DegreeCompletionBlock(block);
  }
}

angular.module('capability-ng-transfer')
  .factory('ngDegreeCompletionBlockBuilder', (ngDegreeCompletionRequirementBuilder: typeof DegreeCompletionRequirement): typeof DegreeCompletionBlock => {
    DegreeCompletionBlock.ngDegreeCompletionRequirementBuilder = ngDegreeCompletionRequirementBuilder;
    return DegreeCompletionBlock;
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/builders/degree_completion_block_builder.ts